import { connect } from 'react-redux';
import DeviceService from '../services/api/device_service';
import DeviceActions from '../actions/device_actions';
import TeamHub from '../components/teamhub/teamhub';

function mapStateToProps({ guest, auth }) {
  return {
    invite: guest.invite,
    user: auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getActions: deviceActions => ({
      pairChromecast: () => dispatch(deviceActions.pairChromecast()),
    }),
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const inviteId = stateProps.invite && stateProps.invite.inviteId;
  const deviceService = new DeviceService(inviteId);
  const deviceActions = new DeviceActions(deviceService);

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps.getActions(deviceActions),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TeamHub);



// WEBPACK FOOTER //
// ./src/containers/teamhub.js